import {
  ADD_DEFAULT_SUB_TASKS,
  ADD_SUB_TASK,
  ADD_TASK_LOCATION,
  CLEAR_NEW_DEFAULT_SUB_TASK,
  CREATE_TASK,
  DELETE_SUB_TASK,
  DELETE_TASK,
  DUPLICATE_TASK,
  EDIT_SUB_TASK,
  EDIT_TASK,
  GET_DEFAULT_SUB_TASKS, // Add new action types
  GET_ITEM_SUB_TASKS,
  GET_MASTER_TASKS,
  GET_SUB_TASKS,
  GET_SUB_TASK_DETAILS,
  GET_SUB_TASK_EVIDENCE,
  GET_TASKS_LIST,
  GET_TASK_DETAILS,
  GET_TASK_LOCATIONS,
  GET_TASK_TYPE,
  UPDATE_SUB_TASK_APPROVAL,
  UPDATE_TASK_STATUS,
  EXPORT_OFFICE_SUBTASK_REPORT,
  EXPORT_ALL_SUBTASK_PUBLIC_ZONE_REPORT,
} from '../../modules/constants';

export function getTasksList(value) {
  return {
    type: GET_TASKS_LIST,
    payload: value,
  };
}

export function createTask(value) {
  return {
    type: CREATE_TASK,
    payload: value,
  };
}

export function getTaskDetails(value) {
  return {
    type: GET_TASK_DETAILS,
    payload: value,
  };
}

export function editTask(value) {
  return {
    type: EDIT_TASK,
    payload: value,
  };
}

export function getDefaultSubTasks(value) {
  return {
    type: GET_DEFAULT_SUB_TASKS,
    payload: value,
  };
}

export function getSubTasks(value) {
  return {
    type: GET_SUB_TASKS,
    payload: value,
  };
}

export function getSubTaskDetails(value) {
  return {
    type: GET_SUB_TASK_DETAILS,
    payload: value,
  };
}

export function addDefaultSubTask(value) {
  return {
    type: ADD_DEFAULT_SUB_TASKS,
    payload: value,
  };
}

export function clearNewDefaultSubTask(value) {
  return {
    type: CLEAR_NEW_DEFAULT_SUB_TASK,
    payload: value,
  };
}

export function getSubTaskEvidence(value) {
  return {
    type: GET_SUB_TASK_EVIDENCE,
    payload: value,
  };
}

export function addSubTask(value) {
  return {
    type: ADD_SUB_TASK,
    payload: value,
  };
}

export function editSubTask(value) {
  return {
    type: EDIT_SUB_TASK,
    payload: value,
  };
}

export function deleteSubTask(value) {
  return {
    type: DELETE_SUB_TASK,
    payload: value,
  };
}

export function duplicateTask(value) {
  return {
    type: DUPLICATE_TASK,
    payload: value,
  };
}

export function deleteTask(value) {
  return {
    type: DELETE_TASK,
    payload: value,
  };
}

export function getTaskLocation(value) {
  return {
    type: GET_TASK_LOCATIONS,
    payload: value,
  };
}

export function updateTaskApproval(value) {
  return {
    type: UPDATE_TASK_STATUS,
    payload: value,
  };
}
export function addTaskLocation(value) {
  return {
    type: ADD_TASK_LOCATION,
    payload: value,
  };
}

export function getTaskType(value) {
  return {
    type: GET_TASK_TYPE,
    payload: value,
  };
}

export function getMasterTasks(value) {
  return {
    type: GET_MASTER_TASKS,
    payload: value,
  };
}

// Add new actions for sub-task approval
export function getItemSubTasks(value) {
  return {
    type: GET_ITEM_SUB_TASKS,
    payload: value,
  };
}

export function updateSubTaskApproval(value) {
  return {
    type: UPDATE_SUB_TASK_APPROVAL,
    payload: value,
  };
}

export function exportOfficeSubtaskReport(value) {
  return {
    type: EXPORT_OFFICE_SUBTASK_REPORT,
    payload: value,
  };
}

export function exportAllSubtaskPublicZoneReport(value) {
  return {
    type: EXPORT_ALL_SUBTASK_PUBLIC_ZONE_REPORT,
    payload: value,
  };
}
